<template>
  <span
    class="remove-favorite-btn"
    @mouseenter="toggleHover"
    @mouseleave="toggleHover"
    @click="removeGoal">
    <i class="fa fa-lg fa-times" aria-hidden="true"/>
  </span>
</template>

<script >
export default {
  name: 'RemoveFavoriteBtn',
  data() {
    return {
      isHovered: false
    }
  },
  computed: {
    collectionId() {
      return this.$store.state.favorites.collectionId
    }
  },
  props: {
    favoriteid: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  methods: {
    removeGoal: function(evt) {
      evt.preventDefault()
      if (confirm(`Are you sure you want to delete this ${this.type} from your favorites?`)) {
        this.$store.dispatch('favorites/deleteFavorite', {
          collectionId: this.collectionId,
          uuid: this.favoriteid,
          type: this.type
        })
      }
    },
    toggleHover: function() {
      this.isHovered = !this.isHovered
    }
  }
}
</script>

<style scoped lang="less">
.remove-favorite-btn {
  position: absolute;
  top: 4px;
  right: 6px;
  display: inline-block;
  padding: 1px 3px;
  border-radius: 3px;
  color: #b94a48;
  font-size: 12px;
  &:hover {
    color: white;
    background-color: #b94a48;
    cursor: pointer;
  }
}
</style>
